module.exports = __webpack_public_path__ + "img/favicon.874eda08.png";